import { css } from '@emotion/core';

export const styles = (theme, customCSS, flags) => {
  return {
    pagination: css`
      & .vds-pagination-page .vds-btn-icon,
      & .vds-pagination-control .vds-btn-icon {
        border: none;
        color: ${theme?.cybs?.core?.primary ?? '#1434cb'};
      }
      & .vds-pagination-control .vds-btn-icon span.vds-btn-label {
        padding: 0 !important;
      }
      & .vds-pagination-page,
      & .vds-pagination-control {
        margin: 0 2px;
      }

      @media (max-width: 480px) {
        & .vds-pagination-page,
        & .vds-pagination-control {
          margin: 0 1px;
        }
      }

      & .vds-pagination-page.vds-state--selected .vds-btn-icon {
        border: 1px solid transparent;
        background-color: ${theme?.cybs?.core?.primary ?? '#2b6afd'};
        color: ${theme?.cybs?.base?.vault?.white ?? '#ffffff'};

        :focus,
        :focus:not(:active) {
          background-color: ${theme?.vds?.tableHighlight ?? '#e6f2ff'};
          color: ${theme?.cybs?.base?.wcag21?.charcoal ?? '#000000'};
        }
      }

      & button svg {
        pointer-events: none;
      }
      ${customCSS && customCSS.length ? customCSS : ''}
    `,
    moreIcon: css`
      width: 1rem !important;
      margin-top: 0.25rem;
      cursor: auto;
      use,
      &.vds-icon--low use {
        fill: ${theme?.cybs?.core?.primary ?? '#1434cb'};
      }
    `,
    button: css`
      &.vds-btn-icon.vds-btn-icon--light-tiny:hover:not(:active) {
        background-color: ${theme?.vds?.tableHighlight ?? '#C7EDFF'};
        border: 1px solid
          ${theme?.variables?.colors?.primaries?.extraDark2 ?? '#021e4c'};
        color: ${theme?.variables?.colors?.primaries?.extraDark2 ?? '#021e4c'};
        & use {
          fill: ${theme?.cybs?.cybs?.core?.primaryDark ?? '#0F2595'};
        }
      }

      &.vds-btn-icon.vds-btn-icon.vds-btn-icon--light-tiny:focus {
        background-color: ${theme?.vds?.tableHighlight ?? '#C7EDFF'};
        color: ${theme?.variables?.colors?.primaries?.extraDark2 ?? '#021e4c'};
        border: none !important;
        outline:  
          ${theme?.variables?.colors?.primaries?.extraDark2 ?? '##021e4c'} 1px dashed;
        outline-offset: 1px;
        & use {
          fill: ${theme?.cybs?.cybs?.core?.primaryDark ?? '#0F2595'};
        }
      }
      &.vds-btn-icon.vds-btn-icon--light-tiny use {
        fill: ${theme?.cybs?.core?.primaryDark ?? '#0F2595'};
      }
    `,
    disabledButton: css`
      /* Repeated class to overwrite !important in button component */
      &.vds-btn-icon.vds-btn-icon.vds-btn-icon {
        border: none !important;
        background-color: unset !important;
        
        &:hover{
          cursor: default;
        }

        &:focus {
          outline: ${theme?.variables?.colors?.primaries?.extraDark2 ?? '##021e4c'} 1px dashed !important;
          outline-offset: 1px;
        }
      }

      &.vds-btn-icon.vds-btn-icon.vds-btn-icon.vds-btn-icon span svg use {
        fill: ${theme?.cybs?.base?.wcag21?.disabledGrey ??
        '#00000033'} !important;
      }
    `
  };
};

export default { styles };
